module.exports = __webpack_public_path__ + "img/icon_map_pgzb.f5fb63cc.png";